import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '@/components/BackButton';
import { useWindowSize } from '@/hooks/useWindowSize';
import { canGoBack } from '@/helpers/utils';
import { APP_LINKS } from '@/helpers/links';
import { ActivityDesktop } from './desktop';
import { ActivityMobile } from './mobile';
import s from './index.module.scss';

const InvestmentStreakActivityPage = () => {
  const { isMobile } = useWindowSize();
  const navigate = useNavigate();
  const { t } = useTranslation('streak');

  const onBack = () => {
    canGoBack() ? navigate(-1) : navigate(APP_LINKS.investmentStreak);
  };

  return (
    <div className="container-inner">
      <div className={s.wrapper}>
        <BackButton onClick={onBack} />
        <div className={s.header}>
          <h2 className="f-hero-h2">
            {t('streak_activity_page.activity_history')}
          </h2>
          <p className="f-paragraph-regular">
            {t('streak_activity_page.track_your_monthly_investment')}
          </p>
        </div>
        {isMobile ? <ActivityMobile /> : <ActivityDesktop />}
      </div>
    </div>
  );
};

export default InvestmentStreakActivityPage;
